import { lazy, Suspense } from 'react';
import { CircularProgress } from '@mui/material';

import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';

const Login = lazy(() => import('components/AUTH/login'));
const Join = lazy(() => import('components/AUTH/signup'));

const Auth = () => {
  let { path } = useRouteMatch();

  return (
    <Suspense fallback={<CircularProgress />}>
      <Switch>
        <Route exact path={`${path}/signup`} component={Join} />
        <Route exact path={`${path}/login`} component={Login} />

        <Route path='*'>
          <Redirect to={`${path}/login`} />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default Auth;
